import React from "react";

export default {
    /**
     *  Add take shipment button on order detail screen
     */
    print_before: [function takeShipmentScreen(component) {
        const CreateShipmentButton = require("../../../../view/component/order/order-detail/CreateShipmentButton").default;
        const { canShip } = component.state;
        const { order } = component.props;
        const { setIsCreatingShipment } = component.props;

        const parentId = order.customer_id;

        return (
            <CreateShipmentButton
                key={'take-shipment-button'}
                order={order}
                canShip={!!canShip}
                associatedCustomer={parentId}
                afterLoadProductQtys={() => canShip && setIsCreatingShipment(true)}
            />
        );
    }]
};


// WEBPACK FOOTER //
// ./src/extension/take-shipment/layout/order/order-detail/order-detail-layout/ActionsLayout.js